import { transLogData } from '@/utils/logUtils'
import { PageModel } from '@/services/apis/setting/module'
import BaseApi from './base'
import { LogConditionModel, LogItemModel } from './module'
class LogApi extends BaseApi {
  async getAuditLog(params: any) {
    const res = await this.post<PageModel<LogItemModel>>('/workspace/listWorkspaceLog', params)
    const newData = transLogData(res.data)
    return {
      ...res,
      data: newData,
    }
  }

  // 获取查询条件
  getCondition() {
    return this.post<LogConditionModel>('/workspace/listQueryCondition', {})
  }
}
export default new LogApi()
